








































































































import {Vue, Component, Watch} from "vue-property-decorator";
import storage from "@/services/local-storage.service";
import dataProxy from "@/services/data-proxy.service";
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

@Component({})
export default class Zaposleni extends mixins(ComponentBaseMixin) {
    filterVisible = false;
    isBusy = false;
    dataOsobe = [];
    tableColumns = [];
    options = {
        search: true,
        pagination: true,
        onClickRow: osoba => this.otvoriDetalje(osoba.id)
    };

    funkcije = [];
    izabraneFunkcije = [];
    vozackeDozvole = ['A', 'B', 'C', 'D', 'E'];
    izabraneDozvole = [];
    poslovnice = [];
    izabranePoslovnice = [];

    view: any = '';
    imeIPrezime = '';
    jmbg = '';
    korisnickoIme = '';

    async created() {
        this.tableColumns = [
            {
                field: "slika",
                width: 80,
                title: this.$i18n.t("slika"),
                formatter: slika =>
                    `<img src="${slika ||
                    "images/userImage.jpg"} " width="64", height="64">`
            },
            {field: "ime", width: 120, title: this.$i18n.t("ime")},
            {field: "prezime", width: 120, title: this.$i18n.t("prezime")},
            {field: "email", width: 120, title: this.$i18n.t("email")},
            {field: "nazivFunkcije", width: 140, title: this.$i18n.t("radnoMesto")},
            {
                field: "nazivRadnogMesta",
                width: 230,
                title: this.$i18n.t("poslovnica")
            }
        ];
        this.isBusy = true;
        try {
            this.dataOsobe = await dataProxy.vratiOsobe(false);
            this.funkcije = await dataProxy.vratiFunkcijeOsoba();
            this.poslovnice = await dataProxy.vratiOrganizacioneJedinice();
            this.isBusy = false;
        } catch (err) {
            this.isBusy = false;
        }

        if (storage.get("osobeView") !== null) {
            this.view = storage.get("osobeView");
        } else {
            this.view = 'CARD_VIEW';
        }
    }

    toggleFilter() {
        this.filterVisible = !this.filterVisible;
    }

    get postavljenFilter() {
        return this.izabraneFunkcije.length > 0 || this.izabraneDozvole.length > 0 || this.izabranePoslovnice.length > 0;
    }

    get zaposleniPrikaz() {
        let osobe = this.dataOsobe;
        if (this.izabraneFunkcije.length > 0) {
            osobe = osobe.filter(o => this.izabraneFunkcije.includes(o.funkcija));
        }
        if (this.izabraneDozvole.length > 0) {
            osobe = osobe.filter(o => this.izabraneDozvole.includes(o.kategorijaVozackeDozvole));
        }
        if (this.izabranePoslovnice.length > 0) {
            osobe = osobe.filter(o => this.izabranePoslovnice.map(p => p.id).includes(o.radnoMestoId));
        }

        if (this.imeIPrezime !== '') {
            osobe = osobe.filter(o => (`${o.ime} ${o.prezime}`).toLowerCase().match(this.imeIPrezime.toLowerCase()))
        }

        if (this.jmbg !== '') {
            osobe = osobe.filter(o => o.jmbg && o.jmbg.match(this.jmbg));
        }

        if (this.korisnickoIme !== '') {
            osobe = osobe.filter(o => o.korisnickoIme && o.korisnickoIme.match(this.korisnickoIme));
        }

        return osobe;

    }

    setView(view: string) {
        this.view = view;
        storage.add("osobeView", this.view);
    }

    kreirajZaposlenog() {
        this.$router.push("/podaci-zaposlenog");
    }

    otvoriDetalje(id) {
        this.$router.push("/pregled-zaposlenog/" + id);
    }
}
